/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
 import {
   NOTIFY,
   FETCH_DATA,
   FETCH_COMPLETE
 } from './types';
import { APPLICABLE_INVOICE_ITEMS } from '../../data/selects';
 import { invoiceItems } from '../../services';

 const services = { invoiceItems };

  export const fetchData = (service, path, url, params = {}) => {
      return (dispatch) => {
          dispatch({ type: FETCH_DATA });
          return services[service].get(url, params).then(result => {
              if(typeof(result.response) === "undefined"){
                onDataLoaded(dispatch, [
                    { path, value: result._embedded.invoiceItems },
                    { path: 'isLoading', value: false },
                    { path: 'numPages', value: result.page.totalPages },
                    { path: 'activePage', value: result.page.number }
                ]);
              }else {
                showErrorMessage(dispatch, result.response.data.message)
              }
          });
      };
  };

  const onDataLoaded = (dispatch, targets) => {
      dispatch({
          type: NOTIFY,
          payload: { op: 'multiUpdate', targets }
      });
  };

 export const notify = (payload) => {
     return {
         type: NOTIFY,
         payload
     };
 };

 export const saveInvoiceItem = (newInvoiceItem) => {

   for(var i=0; i < APPLICABLE_INVOICE_ITEMS.items.length; i++)
   {
     if(APPLICABLE_INVOICE_ITEMS.items[i].id === newInvoiceItem.applicable){
       newInvoiceItem = {
         ...newInvoiceItem,
         applicableRepresentation: APPLICABLE_INVOICE_ITEMS.items[i].name
       }
     }
   }

     return (dispatch) => {
         dispatch({ type: FETCH_DATA });
         return services["invoiceItems"].post("invoiceItems?projection=forListing", newInvoiceItem).then(result => {
           if(typeof(result.response) === "undefined"){
               //Cierro modal de formulario
               dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
               //Añado una nueva aduana a la lista del estado
               dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'invoiceItems', value: result }});
           }else {
             dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
             showErrorMessage(dispatch, result.response.data.message)
           }
         });
     };
 };

 export const saveInvoiceItemFromPreInvoice = (newInvoiceItem) => {

   for(var i=0; i < APPLICABLE_INVOICE_ITEMS.items.length; i++)
   {
     if(APPLICABLE_INVOICE_ITEMS.items[i].id === newInvoiceItem.applicable){
       newInvoiceItem = {
         ...newInvoiceItem,
         applicableRepresentation: APPLICABLE_INVOICE_ITEMS.items[i].name
       }
     }
   }

     return services["invoiceItems"].post("invoiceItems", newInvoiceItem).then(result => {});
 };

 export const editInvoiceItem = (newInvoiceItem, index) => {
     return (dispatch) => {
         dispatch({ type: FETCH_DATA });
         return services["invoiceItems"].put("invoiceItems/" + newInvoiceItem.id, newInvoiceItem).then(result => {
             if(typeof(result.response) === "undefined"){
                   //Cierro modal de formulario
                   dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
                   //Añado una nueva aduana a la lista del estado
                   dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'invoiceItems', value: {index, value: {...result, id: newInvoiceItem.id} }}});
             }else {
               showErrorMessage(dispatch, result.response.data.message)
             }
         });
     };
 };



 export const deleteInvoiceItem = (invoiceItemToRemove, index) =>{
   return (dispatch) => {
       dispatch({ type: FETCH_DATA });
       return services['invoiceItems'].Delete('invoiceItems/'+ invoiceItemToRemove.id).then(result => {
           onDataLoaded(dispatch, [
               { path: 'isLoading', value: false },
               { path: 'showNotification', value: true},
               { path: 'showMessage', value: result.message },
               { path: 'notificationColor', value: result.color }
           ]);
           if(result.color=== '#04B404'){
             dispatch({ type: FETCH_COMPLETE, payload: { op: 'remove', path: 'invoiceItems', value: index } });
           }
       });
   };
 };

 const showErrorMessage = (dispatch, message)  => {
   onDataLoaded(dispatch, [
       { path: 'isLoading', value: false },
       { path: 'showNotification', value: true},
       { path: 'showMessage', value:   message },
       { path: 'notificationColor', value: 'red' }
   ]);
 };



// WEBPACK FOOTER //
// ./containers/conceptos/actions.js